import { resourceForUrl } from './resources';

// Existing clients publish these hints after saves. Never apply their payloads
// as data: refetch through the ordinary authorized API instead.
export function isPilotChange(action, apiBase) {
  const p = action?.payload;
  if (!p || p.version !== 1 || typeof p.id !== 'string' || !p.id || p.id.length > 128
    || typeof p.clientId !== 'string' || !p.clientId || p.clientId.length > 128
    || typeof p.scope !== 'string' || p.scope.length > 2048) return false;
  const resource = resourceForUrl(p.scope, apiBase);
  if (action.type === 'np-schedule/changed') {
    return resource === 'portal:np-schedule' && typeof p.jobNumber === 'string'
      && p.jobNumber.trim().length > 0 && p.jobNumber.length <= 128;
  }
  if (!Number.isSafeInteger(p.projectId) || p.projectId <= 0) return false;
  return (action.type === 'sold-to-ship-to/changed' && resource === 'portal:soldto-shipto-info')
    || (action.type === 'shipping/display-changed' && resource === 'portal:shipping');
}

export function createPilotRuntime({ coordinator, transport, onStatus }) {
  let active = false;
  let release;
  let releaseDomain;
  let receivedDomain = false;
  let previousStatus;
  const seen = new Set();
  return {
    start() {
      active = true;
      coordinator.setEnabled(true);
      releaseDomain = transport.subscribeDomain?.(event => {
        if (!active || !coordinator.receive(event)) return;
        receivedDomain = true;
        onStatus('receiving-domain-events');
      });
      release = transport.subscribe(action => {
        if (!active || !isPilotChange(action, transport.apiBase)) return;
        const key = `${action.payload.clientId}:${action.payload.id}`;
        if (seen.has(key)) return;
        seen.add(key);
        if (seen.size > 500) seen.delete(seen.values().next().value);
        // These writes can affect joined lists. Coalesce a refetch of registered
        // owners rather than inventing field-level dependency information.
        coordinator.catchUp();
      });
    },
    setStatus(status) {
      if (!active) return;
      if (status !== 'Connected') receivedDomain = false;
      onStatus(transport.subscribeDomain
        ? status === 'Connected' ? receivedDomain ? 'receiving-domain-events' : 'connected-awaiting-events' : 'disconnected-domain'
        : status === 'Connected' ? 'connected-pilot' : 'disconnected-pilot');
      if (status === 'Connected' && previousStatus !== status) coordinator.catchUp();
      previousStatus = status;
    },
    setResources() {},
    resume() { if (active && previousStatus === 'Connected') coordinator.catchUp(); },
    dispose() {
      active = false; release?.(); releaseDomain?.(); seen.clear(); coordinator.setEnabled(false);
    },
  };
}
